/* „Gyakran együtt vásárolt" — kiszerelés-illesztés, összeg, kosárba.

   Külön assetben, nem {% javascript %} blokkban: mérve, hogy a Shopify a
   block-scripts.js minifikálásakor a regexbeli \b-t valódi backspace
   karakterré alakítja, amitől a minta némán sosem illeszkedik. */
(function () {
  'use strict';

  // A formazas egy helyen el: assets/pm-money.js.
  function formatHuf(cents) {
    return window.pmMoney.formatHuf(cents);
  }

  // "250g" / "1kg" -> grammban. Szándékosan nincs \b a mintában.
  function gramsOf(title) {
    var m = String(title).match(/(\d+(?:[.,]\d+)?)\s*(kg|g)/i);
    if (!m) return 0;
    var value = parseFloat(m[1].replace(',', '.'));
    if (!isFinite(value) || value <= 0) return 0;
    return m[2].toLowerCase() === 'kg' ? value * 1000 : value;
  }

  /* A kiegészítő ára legfeljebb ennyiszerese lehet a nézett terméknek.
     1,5 azért, hogy a hasonló árú mézek (1.600 Ft akác mellett 2.000 Ft
     aranyvessző) továbbra is a helyes kiszereléssel jelenjenek meg, a
     nagyságrendi ugrások viszont kiessenek. */
  var ARSAPKA = 1.5;

  /* A kiegészítő variánsa a nézett termék kiszereléséhez illeszkedik:
       1. pontosan ugyanaz a gramm
       2. ha nincs, a legközelebbi elérhető LEFELÉ
       3. ha az sincs, VAGY a talált variáns lényegesen drágább a nézett
          terméknél, a legolcsóbb elérhető
     Így 250 g akácmézhez 250 g hársméz jár, nem az 50 g-os minta és nem
     az 1000 g-os, 10.000 Ft-os tétel.

     A 3. pont ársapkája 2026-09-06-án került bele. Mérve: a Lépesméz
     lapján (1000 g) a méhpempőhöz a „legközelebbi lefelé" a 100 g-os,
     16.000 Ft-os doboz volt — a hármas 29.800 Ft-ra jött ki, előre
     bepipálva. A kiszerelés-illesztés grammban gondolkodik, de két
     különböző termékfajta grammja nem egyenértékű, ezért kell az
     ár-fék. Ha egyetlen variáns sem fér a sapka alá (a méhpempő 9.000
     Ft-nál olcsóbban nem kapható), a legolcsóbb marad — ennél jobbat
     nem tudunk ajánlani. */
  function pickVariant(variants, targetGrams, maxPrice) {
    var available = variants.filter(function (v) {
      return v.available && v.price > 0;
    });
    if (!available.length) return null;

    var legolcsobb = available.slice().sort(function (a, b) {
      return a.price - b.price;
    })[0];

    var sized = available.filter(function (v) {
      return gramsOf(v.title) > 0;
    });

    var talalt = null;

    if (targetGrams > 0 && sized.length) {
      var exact = sized.filter(function (v) {
        return gramsOf(v.title) === targetGrams;
      });
      if (exact.length) {
        talalt = exact[0];
      } else {
        var below = sized
          .filter(function (v) {
            return gramsOf(v.title) < targetGrams;
          })
          .sort(function (a, b) {
            return gramsOf(b.title) - gramsOf(a.title);
          });
        if (below.length) talalt = below[0];
      }
    }

    if (talalt && (!(maxPrice > 0) || talalt.price <= maxPrice * ARSAPKA)) {
      return talalt;
    }

    return legolcsobb;
  }

  function buttonLabel(n) {
    if (n >= 3) return 'Mindhármat a kosárba';
    if (n === 2) return 'Mindkettőt a kosárba';
    if (n === 1) return 'Kosárba';
    return 'Válassz legalább egy tételt';
  }

  // A kiegészítő sorok variánsát a nézett termék aktuális kiszereléséhez igazítja.
  function matchPartners(root) {
    var current = root.querySelector('.pm-bundle__item--current');
    var targetGrams = current ? gramsOf(current.dataset.size || '') : 0;
    // A nézett variáns ára az ársapka alapja (fillérben, mint a többi ár).
    var currentPrice = current ? parseInt(current.dataset.price, 10) || 0 : 0;

    root.querySelectorAll('.pm-bundle__item--partner').forEach(function (item) {
      var dataEl = item.querySelector('.pm-bundle__variants');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var chosen = pickVariant(variants, targetGrams, currentPrice);
      if (!chosen) {
        item.hidden = true;
        item.dataset.checked = 'false';
        return;
      }

      item.hidden = false;
      item.dataset.price = chosen.price;
      item.dataset.variantId = chosen.id;

      var priceEl = item.querySelector('[data-role="price"]');
      var sizeEl = item.querySelector('[data-role="size"]');
      if (priceEl) priceEl.textContent = formatHuf(chosen.price);
      if (sizeEl) sizeEl.textContent = chosen.title;
    });
  }

  function refresh(root) {
    var total = 0;
    var count = 0;

    root.querySelectorAll('.pm-bundle__item').forEach(function (item) {
      if (item.hidden) return;
      var input = item.querySelector('.pm-bundle__input');
      var checked = input ? input.checked : true;
      item.dataset.checked = checked ? 'true' : 'false';
      if (!checked) return;
      count++;
      total += parseInt(item.dataset.price, 10) || 0;
    });

    var countEl = root.querySelector('[data-role="count"]');
    var totalEl = root.querySelector('[data-role="total"]');
    var btn = root.querySelector('[data-role="submit"]');

    if (countEl) countEl.textContent = 'Összesen ' + count + ' tétel';
    if (totalEl) totalEl.textContent = formatHuf(total);
    if (btn) {
      btn.textContent = buttonLabel(count);
      btn.disabled = count === 0;
    }
  }

  function render(root) {
    matchPartners(root);
    refresh(root);
  }

  function collect(root) {
    var out = [];
    root.querySelectorAll('.pm-bundle__item').forEach(function (item) {
      if (item.hidden || item.dataset.checked !== 'true') return;
      var id = parseInt(item.dataset.variantId, 10);
      if (id) out.push({ id: id, quantity: 1 });
    });
    return out;
  }

  function submit(root, btn) {
    var items = collect(root);
    if (!items.length) return;

    var original = btn.textContent;
    // 2026-10-10: méhecske (assets/pm-mehecske.js) — a /cart oldalra csak a repülés végén megyünk át.
    var repules = window.pmMehecske ? window.pmMehecske.repulVegig(btn, { felsoSarok: true }) : Promise.resolve();
    btn.disabled = true;
    btn.textContent = 'Kosárba teszem…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        // A referencia szerint a /cart-ra megyünk, nem drawert nyitunk.
        return repules.then(function () { window.location.href = '/cart'; });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        var err = root.querySelector('.pm-bundle__error');
        if (!err) {
          err = document.createElement('p');
          err.className = 'pm-bundle__error';
          root.querySelector('.pm-bundle__summary').appendChild(err);
        }
        err.textContent = 'Nem sikerült kosárba tenni. Próbáld újra.';
      });
  }

  /* 2026-10-25: automatikus mód — a Shopify ajánlómotorja (intent=related) adja a
     kiegészítőket. A kézi párok (bundle_with) a Liquidből már kint vannak; csak
     akkor cseréljük le őket, ha a motor legalább egy elérhető terméket ad. */
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function partnerHtml(p) {
    var variants = p.variants.map(function (v) {
      return { id: v.id, title: v.title, price: v.price, available: v.available };
    });
    var img = p.featured_image
      ? '<img src="' + escapeHtml(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=112') +
        '" alt="' + escapeHtml(p.title) + '" width="56" height="56" loading="lazy">'
      : '';
    return '<label class="pm-bundle__item pm-bundle__item--partner" data-checked="true">' +
      '<script type="application/json" class="pm-bundle__variants">' + JSON.stringify(variants).replace(/</g, '\\u003c') + '<\/script>' +
      '<input type="checkbox" class="pm-bundle__input" checked>' +
      '<span class="pm-bundle__check" aria-hidden="true"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"></path></svg></span>' +
      '<span class="pm-bundle__media">' + img + '</span>' +
      '<span class="pm-bundle__info"><span class="pm-bundle__name">' + escapeHtml(p.title) + '</span>' +
      '<span class="pm-bundle__price-row"><span class="pm-bundle__price" data-role="price"></span><span class="pm-bundle__size" data-role="size"></span></span></span>' +
      '</label>';
  }

  function loadAuto(root) {
    var url = root.dataset.pmAuto;
    if (!url) return Promise.resolve();
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var ownId = Number(root.dataset.productId);
        var picks = ((data && data.products) || []).filter(function (p) {
          return p.id !== ownId && p.available;
        }).slice(0, 2);
        if (!picks.length) return;
        var items = root.querySelector('.pm-bundle__items');
        items.querySelectorAll('.pm-bundle__item--partner').forEach(function (el) { el.remove(); });
        items.insertAdjacentHTML('beforeend', picks.map(partnerHtml).join(''));
        var title = root.querySelector('[data-role="title"]');
        if (title) title.textContent = picks.length === 2 ? 'Ez a hármas jól megy egymáshoz' : 'Ez a kettő jól megy egymáshoz';
        root.dataset.pmSource = 'auto';
      })
      .catch(function () { /* marad a kézi tartalék */ })
      .then(function () {
        var band = root.closest('.pm-bundle-band');
        if (band && root.querySelector('.pm-bundle__item--partner')) band.hidden = false;
      });
  }

  function init(root) {
    if (root.dataset.pmBundleInit) return;
    root.dataset.pmBundleInit = '1';
    loadAuto(root).then(function () { start(root); });
  }

  function start(root) {

    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('pm-bundle__input')) refresh(root);
    });

    var btn = root.querySelector('[data-role="submit"]');
    if (btn) {
      btn.addEventListener('click', function () {
        submit(root, btn);
      });
    }

    render(root);
  }

  function initAll() {
    document.querySelectorAll('.pm-bundle').forEach(init);
  }

  /* Kiszerelés-váltáskor a nézett termék sora ÉS a kiegészítők variánsa
     is újraszámol — 500 g akácmézhez 500 g hársméz kerül. */
  document.addEventListener('variant:update', function (e) {
    if (!e.detail || !e.detail.resource) return;
    var productId = e.detail.data && e.detail.data.productId;
    var variant = e.detail.resource;

    document.querySelectorAll('.pm-bundle').forEach(function (root) {
      if (productId && root.dataset.productId !== String(productId)) return;
      var item = root.querySelector('.pm-bundle__item--current');
      if (!item) return;

      item.dataset.price = variant.price;
      item.dataset.variantId = variant.id;
      item.dataset.size = variant.title;

      var priceEl = item.querySelector('[data-role="price"]');
      var sizeEl = item.querySelector('[data-role="size"]');
      if (priceEl) priceEl.textContent = formatHuf(variant.price);
      if (sizeEl) sizeEl.textContent = variant.title;

      render(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // 2026-09-13 (audit KOD-05): Theme Editor szekcio-ujrarender utan is (a data-*Init orszem vedi a dupla kotest).
  document.addEventListener('shopify:section:load', initAll);
})();